import ReassignmentView from '@/views/app/reassignment/reassignment.view.vue'
import ReassignmentGuards from '@/guards/reassignment.guards'

export default [
  {
    path: 'reassignment',
    name: 'reassignment',
    component: ReassignmentView,
    beforeEnter: ReassignmentGuards.onQuery()
  }
]



// WEBPACK FOOTER //
// ./src/router/app/reassignment/index.js